import { cn } from '@newfront-insurance/core-ui/v2';
import type { ReactNode } from 'react';

interface ChatHeaderProps {
  children: ReactNode;
  className?: string;
}

/**
 * Header wrapper component for chat interface.
 * Accepts children for flexible composition of header actions.
 *
 * @example
 * ```tsx
 * <ChatHeader>
 *   <NewChatButton />
 *   <ToggleSidebar />
 *   <AccountSelector />
 *   <ChatHeaderActions />
 * </ChatHeader>
 * ```
 */
export function ChatHeader({ children, className }: ChatHeaderProps) {
  return (
    <header
      className={cn(
        'border-steel-75 flex h-14 shrink-0 items-center justify-between rounded-t-sm border-b bg-white px-6',
        className,
      )}
    >
      {children}
    </header>
  );
}
